import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MenuItem, Modal, Button, Dropdown } from 'react-bootstrap';

import { truncate, filter, find, slice } from 'lodash';
import Fa from 'react-fontawesome';
import SearchField from '../search-field';
import styles from './styles.css';
// Import Actions
import { searchOrganization, requestPretentOrganization } from '../../modules/Auth/AuthActions';

// Import Selectors
import { getUser } from '../../modules/Auth/AuthReducer';
import enhanceWithClickOutside from 'react-click-outside';
import Avatar from '../avatar';

const maxResults = 15;

class OwnerSelector extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      query: null,
      modalQuery: null,
      openModal: false,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleOwnerSelect = this.handleOwnerSelect.bind(this);
    this.handleOwnerSelectFromModal = this.handleOwnerSelectFromModal.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleModalSearch = this.handleModalSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  handleClickOutside() {
    if (!this.state.openModal) {
      this.setState({ open: false });
    }
  }

  handleToggle(open) {
    if (!this.state.open) {
      const { owners } = this.props;
      if (owners.length <= maxResults) {
        this.setState({ open });
      } else {
        this.setState({ openModal: true });
      }
    }
  }

  handleOwnerSelect(owner) {
    this.props.onSelect(owner);
    this.setState({ open: false, query: null });
  }
  handleOwnerSelectFromModal(owner) {
    this.props.onSelect(owner);
    this.setState({
      open: false, openModal: false, query: null, modalQuery: null,
    });
  }
  handleSearch(query) {
    this.setState({ query });
  }
  handleModalSearch(modalQuery) {
    this.setState({ modalQuery });
  }
  handleOpenModal() {
    this.setState({ openModal: true, modalQuery: this.state.query });
  }
  handleCloseModal() {
    this.setState({ openModal: false });
  }

  renderOwnerItem(owner) {
    const { ownerId } = this.props;

    const displayName = owner.display_name || owner.name;
    const isActive = owner.user_id === ownerId;
    const id = owner.user_id;
    return (
      <MenuItem
        active={isActive}
        eventKey={owner}
        key={id}
        onSelect={this.handleOwnerSelect}
        className={styles.item}
      >
        <span>
          <Avatar user={owner} size={24} className={styles.avatar} /> {(owner.display_name || owner.name)}
        </span>
      </MenuItem>
    );
  }

  renderModal() {
    const { ownerId, owners } = this.props;

    const { openModal, modalQuery } = this.state;

    const owner = find(owners, { user_id: ownerId });
    let sortedData = owners;
    const re = modalQuery && modalQuery.trim().length ? new RegExp(modalQuery, 'i') : null;
    const isSearching = re !== null;
    sortedData = filter(sortedData, (data) => {
      let matchedKeyword = true;
      if (re) {
        const name = data.display_name || data.name || '';
        matchedKeyword = name.match(re);
      }
      return matchedKeyword;
    });
    const hasData = sortedData.length > 0;


    return (
      <Modal
        show={openModal}
        onHide={this.handleCloseModal}
      >
        <Modal.Header closeButton>
          <h4>Sales Rep Selector</h4>
        </Modal.Header>
        <Modal.Body>
          <div>
            {openModal && <SearchField
              collapsible={false}
              onSearch={this.handleModalSearch}
              query={this.state.modalQuery}
              autoFocus
            />}
          </div>
          <p />
          {sortedData.length > 0 && <div className={`list-group ${styles.listGroup}`}>
            {sortedData.map((o) => {
              const active = owner && owner.user_id === o.user_id;
              return (
                <a
                  href=""
                  className={`list-group-item ${active ? 'active' : ''}`}
                  key={o.user_id}
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleOwnerSelectFromModal(o);
                  }}
                >
                  <span><Avatar user={o} size={24} className={styles.avatar} /> {(o.display_name || o.name)}</span>
                </a>
              );
            })}
          </div>}
          {sortedData.length === 0 &&
            <div className="well">
              {isSearching && <div>No results found matching <code>{modalQuery}</code></div>}
              {!isSearching && <div>No results found.</div>}
            </div>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className="clearfix">
            {owner !== undefined &&
              <Button className="pull-left" onClick={() => { this.handleOwnerSelectFromModal(null); }} bsStyle="link">
                Reset
              </Button>
            }
            <Button className="pull-right" onClick={this.handleCloseModal} bsStyle="link">
              Cancel
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { ownerId, owners } = this.props;
    const {
      open, query,
    } = this.state;


    const owner = find(owners, { user_id: ownerId });
    let sortedData = owners;
    const re = query && query.trim().length ? new RegExp(query, 'i') : null;
    const isSearching = re !== null;
    sortedData = filter(sortedData, (data) => {
      let matchedKeyword = true;
      if (re) {
        const name = data.display_name || data.name || '';
        matchedKeyword = name.match(re);
      }
      return matchedKeyword;
    });
    const hasData = sortedData.length > 0;
    const title = owner ? owner.display_name || owner.name : this.props.emptyText;
    const showReset = !isSearching && owners.length > 0 && owner !== undefined;
    const truncatedResults = slice(sortedData, 0, maxResults);
    const remaining = sortedData.length - truncatedResults.length;

    return (
      <span>
        <Dropdown
          onToggle={this.handleToggle}
          open={open}
          id="owner-selector"
        >
          <Dropdown.Toggle bsSize="small">
            <span>
              {title}
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu className={styles.list}>
            {owners.length > 0 && open && owners.length > maxResults &&
              <li
                className={styles.searchRow}
              >
                <SearchField
                  collapsible={false}
                  onSearch={this.handleSearch}
                  query={query}
                  autoFocus
                />
              </li>
            }
            {truncatedResults.length > 0 && truncatedResults.map(o => this.renderOwnerItem(o))}
            {remaining > 0 &&
              <MenuItem
                eventKey={null}
                onSelect={this.handleOpenModal}
                className={`${styles.item} ${styles.itemMore}`}
              >
                <span className="text-active">show all <label className="badge">{sortedData.length}</label></span>
              </MenuItem>
            }
            {showReset &&
              <MenuItem divider />
            }
            {showReset &&
              <MenuItem
                active={ownerId === null}
                eventKey={null}
                onSelect={this.handleOwnerSelect}
                className={`${styles.item} text-center`}
              >
                <span>{this.props.emptyText}</span>
              </MenuItem>
            }
            {sortedData.length === 0 && <MenuItem className="text-center" disabled>
              <span>No records found.</span>
            </MenuItem>}
          </Dropdown.Menu>
        </Dropdown>
        {this.renderModal()}
      </span>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

OwnerSelector.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  user: PropTypes.shape({}).isRequired,
  ownerId: PropTypes.string,
  owners: PropTypes.arrayOf(PropTypes.shape({})),
  emptyText: PropTypes.string,
};
OwnerSelector.defaultProps = {
  owners: [],
  PropTypes: null,
  onSelect: () => {},
  emptyText: 'No Comparison',
};
export default connect(mapStateToProps)(enhanceWithClickOutside(OwnerSelector));
